import React from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

import IconButton from "@src/sharedComponents/IconButton/IconButton";

import styles from "./shared.module.css";

export const TableContainerV2 = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  const {
    color: { $borderBold },
  } = useTheme();
  return (
    <div
      style={{
        border: `1px solid ${$borderBold}`,
        borderRadius: "5px",
        overflow: "auto",
        width: "100%",
        marginBottom: "25px",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

type TableHeaderV2Props = {
  onBack?: () => void;
  leftTitle: React.ReactNode;
  middleTitle?: string;
  rightTitle: React.ReactNode;
};

export const TableHeaderV2: React.FC<TableHeaderV2Props> = ({
  onBack,
  rightTitle,
  leftTitle,
  middleTitle,
}) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        {onBack !== undefined && (
          <IconButton
            size="small"
            iconClassName={styles.headerBackIcon}
            onClick={onBack}
            IconComponent={ArrowBackIcon}
          />
        )}
        <div className={styles.description}>{leftTitle}</div>
      </div>
      <div>{middleTitle}</div>

      <div className={styles.headerRight}>{rightTitle}</div>
    </div>
  );
};
